import { FC } from "react";

import styles from "./MyTablesSubmissionsPage.module.css";

import { useLoggedInContext } from "shared/LoggedInContext";

import { UploadedTablesSection } from "./UploadedTablesSection";

export const MyTablesSubmissionPage: FC = () => {
  const { session, activeContext } = useLoggedInContext();

  return (
    <div className={styles.page}>
      <section>
        <h2>Data</h2>
      </section>
      <UploadedTablesSection
        session={session}
        activeContext={activeContext}
        canEdit
      />
    </div>
  );
};
